import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'

import {
  Container,
  Row,
  Image,
  NumberCircle,
  SubTitle,
  InfoText,
  LinkContainer,
  Button,
  LinkButton,
  DangerButton
} from './styles'

export default function Professional ({
  data: professional,
  onDelete: handleDelete,
  onRestore: handleRestore
}) {
  const [showDeleteDialog, setShowDeleteDialog] = useState (false)
  const [showReactivateDialog, setShowReactivateDialog] = useState (false)
  const [showRestoreDialog, setShowRestoreDialog] = useState (false)
  const [errorMessage, setErrorMessage] = useState (null)
  const [deleting, setDeleting] = useState (false)
  const [retoring, setRestoring] = useState (false)
  const hasEditPermission = AuthService.hasPermission ('business_config.professionals', 'edit')
  const hasDeletePermission = AuthService.hasPermission ('business_config.professionals', 'delete')
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const deleteProfessional = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (
        `/businesses/${businessId}/professionals/${professional.id}`,
        requestConfig
      )
      setDeleting (false)
      handleDelete (professional)
    } catch (error) {
      setDeleting (false)
      setErrorMessage (getApiErrorMessage (error))
      logApiError (error)
    }
  }

  const reactivateProfessional = async () => {
    setRestoring (true)
    try {
      await cutileiApi.put (
        `/businesses/${businessId}/professionals/${professional.id}/activation`,
        {active: true},
        requestConfig
      )
      setRestoring (false)
      handleRestore ({ ...professional, active: true })
    } catch (error) {
      setRestoring (false)
      logApiError (error)
    }
  }

  const restoreProfessional = async () => {
    setRestoring (true)
    try {
      await cutileiApi.post (
        `/businesses/${businessId}/professionals/${professional.id}/restore`, {}, requestConfig
      )
      setRestoring (false)
      handleRestore ({ ...professional, active: true })
    } catch (error) {
      setRestoring (false)
      logApiError (error)
    }
  }

  const toggleDeleteDialog = () => setShowDeleteDialog (!showDeleteDialog)
  const toggleReactivateDialog = () => setShowReactivateDialog (!showReactivateDialog)
  const toggleRestoreDialog = () => setShowRestoreDialog (!showRestoreDialog)

  return (
    <Container>
      <Row>
        <NumberCircle>
          <SubTitle>
            {professional.number}
          </SubTitle>
        </NumberCircle>
        <Image src={professional.profile_picture}/>
        <InfoText>
          {professional.name}
        </InfoText>
      </Row>
      {!professional.deleted ? (
        <Row>
          <SubTitle style={{
            color: professional.active ? '#44CF6C' : '#FF3939',
            justifySelf: 'flex-end',
            marginRight: 5
          }}>
            {professional.active ? 'Ativo' : 'Inativo'}
          </SubTitle>
          <LinkContainer>
            {!professional.active && hasEditPermission && (
              <Button onClick={toggleReactivateDialog}>
                {retoring ? (
                  <ButtonLoading/>
                ) : (
                  <SubTitle>Reativar</SubTitle>
                )}
              </Button>
            )}
            {hasEditPermission && (
              <LinkButton to={`/business/professionals/${professional.id}/edit`}>
                <FA.FaPencilAlt/>
              </LinkButton>
            )}
            {hasDeletePermission && (
              <DangerButton onClick={toggleDeleteDialog}>
                {deleting ? (
                  <ButtonLoading style={{margin: 0}}/>
                ) : (
                  <FA.FaTrash/>
                )}
              </DangerButton>
            )}
          </LinkContainer>
        </Row>
      ) : (
        <Row>
          {hasEditPermission && (
            <Button onClick={toggleRestoreDialog}>
              {retoring ? (
                <ButtonLoading/>
              ) : (
                <SubTitle>Restaurar</SubTitle>
              )}
            </Button>
          )}
        </Row>
      )}
      <AlertDialog
        visible={showDeleteDialog}
        title='Atenção!'
        message='Deseja realmente excluir este profissional?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteProfessional}
        onClose={toggleDeleteDialog}
        dangerous
      />
      <AlertDialog
        visible={showReactivateDialog}
        title='Atenção!'
        message='Deseja realmente reativar este profissional na agenda?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={reactivateProfessional}
        onClose={toggleReactivateDialog}
      />
      <AlertDialog
        visible={showRestoreDialog}
        title='Atenção!'
        message='Deseja realmente restaurar este profissional?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={restoreProfessional}
        onClose={toggleRestoreDialog}
      />
      <AlertDialog
        visible={errorMessage !== null}
        title='Erro'
        message={errorMessage}
        confirmText='Ok'
        onConfirm={() => setErrorMessage (null)}
        onClose={() => setErrorMessage (null)}
        containerStyle={{width: 480}}
      />
    </Container>
  )
}
